import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    title: "Sign up for your free mailbox",
    desc: "Create your account in minutes and receive your own US shipping address — completely free.",
  },
  {
    num: "02",
    title: "Shop online, anywhere",
    desc: "Buy from your favourite US stores and ship everything to your new BEC mailbox address.",
  },
  {
    num: "03",
    title: "We ship & clear customs",
    desc: "Your packages fly or sail to Jamaica. We consolidate, handle customs and all the paperwork.",
  },
  {
    num: "04",
    title: "Delivered to your door",
    desc: "Pick up in Linstead or get door-to-door delivery in and around Spanish Town, St Catherine. Shipping, done easy.",
  },
];

export const HowItWorks = () => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="py-28 sm:py-36 border-t border-white/10 bg-[#1C0D2C]/30"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-20 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6"
      >
        <div>
          <p className="font-mono-accent text-xs tracking-[0.3em] uppercase text-[#FF8A00] mb-4">
            The process
          </p>
          <h2 className="font-display font-800 tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
            Four steps to your doorstep
          </h2>
        </div>
        <a
          data-testid="how-it-works-signup-cta"
          href="https://becc.takumiwhm.com/auth/register?tenantHost=becc.takumiwhm.com&returnUrl=https%3A%2F%2Fbecc.takumiwhm.com"
          target="_blank"
          rel="noreferrer"
          className="group shrink-0 px-6 py-3 rounded-full border border-white/20 hover:bg-white/10 transition-colors duration-200 flex items-center gap-2 text-sm"
        >
          Start now — it's free
          <ArrowUpRight className="w-4 h-4 text-[#FF8A00] transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </motion.div>

      <div>
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`chapter-${c.num}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.05 * i }}
            className="group grid grid-cols-[auto_1fr] sm:grid-cols-[10rem_1fr] gap-6 sm:gap-12 py-10 border-t border-white/10 items-baseline"
          >
            <span className="font-mono-accent font-800 text-5xl sm:text-7xl text-stroke-amber transition-colors duration-300 group-hover:text-[#FF8A00] group-hover:[-webkit-text-stroke:0px]">
              {c.num}
            </span>
            <div className="max-w-2xl">
              <h3 className="font-display font-700 tracking-tight text-2xl sm:text-3xl">
                {c.title}
              </h3>
              <p className="mt-3 text-[#A29DB0] text-sm sm:text-base leading-relaxed">
                {c.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
